var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeWhiteIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.822,
    viewBox: "0 0 15 15.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_2_",
    "data-name": "image(2)",
    d: "M10,2.09a2.187,2.187,0,0,0-1.353.467L3.69,6.462A3.127,3.127,0,0,0,2.5,8.917v7.536a1.468,1.468,0,0,0,1.458,1.459H16.042A1.468,1.468,0,0,0,17.5,16.453V8.917a3.13,3.13,0,0,0-1.191-2.455l-.059-.047V3.125a.625.625,0,0,0-.625-.625H13.542a.625.625,0,0,0-.625.625v.664L11.352,2.557A2.183,2.183,0,0,0,10,2.09Zm0,1.247a.937.937,0,0,1,.58.2l2.575,2.029a.625.625,0,0,0,1.012-.49V3.75H15V6.719a.626.626,0,0,0,.238.49l.3.235a1.876,1.876,0,0,1,.714,1.473v7.536a.2.2,0,0,1-.208.209H3.958a.2.2,0,0,1-.208-.209V8.917a1.873,1.873,0,0,1,.715-1.473l4.955-3.9a.935.935,0,0,1,.58-.2ZM6.042,9.995a.625.625,0,0,0-.625.625v3.334a.625.625,0,0,0,.625.624h2.5a.625.625,0,0,0,.625-.624V10.62A.625.625,0,0,0,8.542,10Zm5.416,0a.625.625,0,0,0-.625.625v3.334a.625.625,0,0,0,.625.624h2.5a.626.626,0,0,0,.625-.624V10.62A.625.625,0,0,0,13.958,10Zm-4.791,1.25h1.25v2.084H6.667V11.245Zm5.416,0h1.25v2.084h-1.25V11.245Z",
    transform: "translate(-2.5 -2.09)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWhiteIcn);
export default __webpack_public_path__ + "static/media/homeWhite-icn.39e480bedc8e256781e3ab8a458d4d9b.svg";
export { ForwardRef as ReactComponent };